/* keep-alive 搜索 页面 缓存*/

const keepAlive = {
	state: {
		cachedViews: []
	},

	mutations: {
		ADD_CACHED_VIEW: (state, viewname) => {
			if(state.cachedViews.includes(viewname)) {
				return
			} else {
				state.cachedViews.push(viewname)
			}
		},
		DELALL_CACHED_VIEW: (state, viewname) => {
			state.cachedViews = [];
		},
		DEL_CACHED_VIEW: (state, viewname) => {
			for(const i of state.cachedViews) {
				if(i === viewname) {
					const index = state.cachedViews.indexOf(i)
					state.cachedViews.splice(index, 1)
					break
				}
			}
		},
	},

	actions: {
		addCachedView({
			commit,
			state
		}, view) {
		    console.warn('here!!come in now! addCachedView');
			commit('ADD_CACHED_VIEW', view)
		},
		delAllCachedView({
			commit,
			state
		}) {
			commit('DELALL_CACHED_VIEW')
		},
		delCachedView({
			commit,
			state
		}, view) {
			return new Promise(resolve => {
				commit('DEL_CACHED_VIEW', view)
				resolve([...state.cachedViews])
			})
		},
	}
}

export default keepAlive



// WEBPACK FOOTER //
// ./src/store/modules/keepAlive.js